import {
  giftedCouponListQueryOption,
  useInfiniteScrollQuery,
} from 'src/hooks/react-query/useCustomInfiniteQuery.hook'
import { GiftedCouponListSpace, ResponseDataType } from 'src/types/api'
import React, { Dispatch, SetStateAction, useCallback } from 'react'
import usePageNav from 'src/hooks/usePageNav.hook'
import { Loading } from 'src/components/common/Loading'
import RenderIf from 'src/components/common/RenderIf'
import GiftedCouponPageView from 'src/pages/GiftedCouponPage/view'

export interface GiftedCouponPageProps {
  setTarget: Dispatch<SetStateAction<HTMLDivElement | null | undefined>>
  giftedCouponListData: GiftedCouponListSpace.GiftedCouponListInterface[]
  giftedCouponNoMore: boolean
  itemsOfStatus: { [key: string]: { text: string; color: string } }
  purchaseHistoryDetailPageNav: (
    Idx: number,
    couponIdx: number,
    couponStatus: string,
    couponType: number,
    couponNumber: string,
  ) => void
}

const itemsOfStatus: { [key: string]: { text: string; color: string } } = {
  '0': { text: '선물 받는 중', color: 'var(--black-50)' },
  '1': { text: '수신 완료', color: 'var(--black-50)' },
  '2': { text: '수신 거절', color: 'var(--black-50)' },
  '3': { text: '선물 취소', color: 'var(--black-50)' },
}

const GiftedCouponPage = () => {
  const { purchaseHistoryDetailPageNav } = usePageNav()

  const {
    data: giftedCouponListQueryData,
    isPending: isGiftedCouponListPending,
    setTarget,
  } = useInfiniteScrollQuery<GiftedCouponListSpace.Request, GiftedCouponListSpace.Response>(
    giftedCouponListQueryOption(),
  )

  const giftedCouponListProcessData = useCallback(() => {
    let result: GiftedCouponListSpace.GiftedCouponListInterface[] | any[] = []

    giftedCouponListQueryData?.pages?.map(
      // eslint-disable-next-line array-callback-return
      (element: ResponseDataType<GiftedCouponListSpace.Response>) => {
        !!element?.Body?.GiftList && result.push(...element?.Body?.GiftList)
      },
    )

    return {
      result,
      noMore: !giftedCouponListQueryData?.pages?.at(-1)?.Body?.GiftList?.length,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [giftedCouponListQueryData])

  const props = {
    setTarget,
    itemsOfStatus,
    giftedCouponListData: giftedCouponListProcessData().result,
    giftedCouponNoMore: giftedCouponListProcessData().noMore,
    purchaseHistoryDetailPageNav,
  }

  return (
    <React.Fragment>
      <RenderIf when={isGiftedCouponListPending}>
        <Loading.Default />
      </RenderIf>
      <GiftedCouponPageView {...props} />
    </React.Fragment>
  )
}
export default GiftedCouponPage
